// src/pages/Home.tsx

import { Box, Typography } from "@mui/material";

const Home = () => {
    return (
        <Box sx={{
            flexGrow: 1,
            backgroundColor: 'whitesmoke',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: "100%"
        }}>
            <Typography variant="h3">Notifications & Alerts will show up here...</Typography>
        </Box>
    );
};

export default Home;